import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReorderListSourcingRBAC = {
  pageID: '10026cd5eea52d8a872c3127d816ad10',
  elementID: {
    ReviewPo: 'f1b3251a86b6da1cf54400dd39b12f5b',
    EditVendorDetail: '37e467554ec397a2df99a2e64b614f21',
    EditRlVendor: 'cc994866e3c3870d794bc76c3c5dbf18',
    ViewRLSourcing: 'f541842327df9bef31efb3500cbff87f',
    DeleteRlAndVendor: '2581f685ee86df309af59dc21469c30c',
    RequestUpdate: 'deed1effcbaa47f5ea1b4592c8165765',
    ViewRlHistory: '16b3dc49bd2207cf2f71888e0ba37933',
    ViewRequestUpdate: 'c404d20028a0edee95d1ff60fec167a5',
    SaveRL: '5ffc24b1abd424556c865af98ccce4b9',
  },
}
export const useRBACReorderListSourcingPage = createUseRBAC(ReorderListSourcingRBAC.elementID)
export type UseRBACReorderListSourcingPageType = ReturnType<typeof useRBACReorderListSourcingPage>

export const ReorderListPreviewRBAC = {
  pageID: '30e3c83299bf822d2361f9ec406ef432',
  elementID: {
    ViewRlPreview: '807adc94bce4a7f96db6e481eb5da289',
    CreatePo: '8edd71f05776daf06b21c56e5ade14b9',
    DraftPo: '6275013662d47dd9c0e9c0833fb90fe0',
    DeletePo: '03acc4ec1176daf05fd4103976d5a08c',
    EditDiscount: '637fc0cc32d4987da4720e2ab6a69dbf',
  },
}
export const useRBACReorderListPreviewPage = createUseRBAC(ReorderListPreviewRBAC.elementID)
export type UseRBACReorderListPreviewPageType = ReturnType<typeof useRBACReorderListPreviewPage>

export const ReorderListScRBAC = {
  pageID: 'e89f83d84a4f73e89ee6b9bceae3aa58',
  elementID: {
    ViewRlSc: 'd8ba9216fe90a2384cdbc092ffdfd90f',
    ViewHistoryRl: 'd14d12ff5fdb4f9b3e2779c6fa592b8f',
    DownloadRl: '836489fc51ab9d0ae1fe77c838f996d2',
    BulkUploadRl: '6cd60c16c891641e21499fc183f11eb9',
  },
}
export const useRBACReorderListScPage = createUseRBAC(ReorderListScRBAC.elementID)
export type UseRBACReorderListScPageType = ReturnType<typeof useRBACReorderListScPage>

export const ReorderListHistoryRBAC = {
  pageID: 'debee5cbf7bf822d23b565ff5e26d58e',
  elementID: {
    ViewRlHistory: '1297b9fe57a1eb70ab4ac3a7d08bcb05',
  },
}
export const useRBACReorderListHistoryPage = createUseRBAC(ReorderListHistoryRBAC.elementID)
export type UseRBACReorderListHistoryPageType = ReturnType<typeof useRBACReorderListHistoryPage>
